<template>
  <div class="page">
    <div class="container">
        <!-- <h1>jQuery自适应PC端和移动端案例</h1> -->
        <!-- <div class="headPic"></div> -->
        <!-- <div class="box" id="infoBox">
            当前设备：检测中...
        </div> -->
        <div class="info" v-if="processing === 'first'">
        </div>
        <div v-if="processing === 'first'">
            <div style="margin-top: 15px;">
                <img src="../img/biaoti.jpg" style="width: 20%;height: 20px;margin: 0 auto;" alt="">
            </div>
            <div style="margin-top: 15px;">
                <img src="../img/wenan1.jpg" style="width: 85%;height: 48px;margin: 0 auto;" alt="">
            </div>
            <div style="margin-top: 15px;">
                <img src="../img/wenan2.jpg" style="width: 85%;height: 48px;margin: 0 auto;" alt="">
            </div>
            <div style="margin-top: 15px;">
                <img src="../img/wenan3.jpg" style="width: 85%;height: 48px;margin: 0 auto;" alt="">
            </div>
        </div> 
        <!-- <div class="jiantou">
        </div> -->
        <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top: 10px;" v-if="processing === 'first'">
            <input type="text" id="stockCode" class="form-control mb-3 contentInput" placeholder="会社名またはテッカーを入力">
            <button class="btn btn-primary contentButton"  id="startDiagnosis" @click="startProcess()">
                <!-- <img src="../img/anniuwenan.png" alt="" style="width: 85%;height: 100%;margin: 0 auto;"> -->
            </button>
        </div>
        <div class="fenxi" v-if="processing === 'second'">
        </div>
        <div v-if="processing === 'second'" style="margin-top: 20px;">
            <div style="width: 80%;display: block;height: 32px;margin: 0 auto;">
                <img src="../img/FENXI1.png" alt="" style="width: 60px;height: 24px;float: left;">
                <img src="../img/GOU.png" alt="" style="width: 24px;height: 24px;float: left;" v-if="fenxi1">
            </div>
            <div class="progress-bg" style="margin: 0 auto;width: 80%;">
        <!-- 进度条主体（通过宽度控制进度） -->
                <div
                    class="progress-bar"
                    :style="{ width: `${progress1}%` }"
                ></div>
            </div>
        </div>

        <div v-if="processing === 'second'" style="margin-top: 10px;">
            <div style="width: 80%;display: block;height: 32px;margin: 0 auto;">
                <img src="../img/FENXI2.png" alt="" style="width: 80px;height: 24px;float: left;">
                <img src="../img/GOU.png" alt="" style="width: 24px;height: 24px;float: left;" v-if="fenxi2">
            </div>
            <div class="progress-bg" style="margin: 0 auto;width: 80%;">
        <!-- 进度条主体（通过宽度控制进度） -->
                <div
                    class="progress-bar"
                    :style="{ width: `${progress2}%` }"
                ></div>
            </div>
        </div>

        <div v-if="processing === 'second'" style="margin-top: 10px;">
            <div style="width: 80%;display: block;height: 32px;margin: 0 auto;">
                <img src="../img/FENXI3.png" alt="" style="width: 80px;height: 24px;float: left;">
                <img src="../img/GOU.png" alt="" style="width: 24px;height: 24px;float: left;" v-if="fenxi3">
            </div>
            <div class="progress-bg" style="margin: 0 auto;width: 80%;">
        <!-- 进度条主体（通过宽度控制进度） -->
                <div
                    class="progress-bar"
                    :style="{ width: `${progress3}%` }"
                ></div>
            </div>
        </div>

        <div class="info2" v-if="processing === 'third'">
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top: 10px;" v-if="processing === 'third'">
            <button class="btn btn-primary contentButton2"  id="startDiagnosis" @click="getReportBtn()">
                <!-- <img src="../img/LINE.png" alt="" style="width: 100%;height: 100%;margin: 0 auto;"> -->
            </button>
        </div>
        <!-- <div class="box">
            <button id="actionBtn">点击测试自适应按钮</button>
        </div> -->
        <div id="diagnosisPopup" class="popup">
            <h3>診断進行中...</h3>
            <p id="progressText">診断中...</p>
            <div class="progress mt-3">
                <div id="progressBar" class="progress-bar progress-bar-striped progress-bar-animated" style="width: 0%;"></div>
            </div>
        </div>
        <div id="resultPopup" class="popup">
            <!-- 动态显示股票代码 -->
            <h3 id="resultTitle">AI分析レポート完成</h3>
            <hr> <!-- 分割线 -->
            <p id="resultText">読み込み中...</p> <!-- 诊断结果描述 -->
            <a class="btn btn-success btn-report" id="getReportBtn" @click="getReportBtn()" style="background-color: #20C930;">LINEを追加してAI分析レポートを受け取る</a>
        </div>

    </div>
    <div class="footer">
            <div style="padding-top: 10px;">プライバシーポリシー</div>
            <div style="padding: 10px;">© 2025 AI株式分析. All Rights Reserved.</div>
        </div>
    <!-- <div class="footer">
        <img src="../img/banquan.png" style="width: 100%;height: 100%;margin: 0 auto;" alt="">
    </div> -->
    
  </div>
</template>

<script src="../js/jquery-3.7.1.min.js"></script>
<script>
import { set } from 'vue';
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      script: null,
      config: {},
      progress1: 0,
      progress2: 0,
      progress3: 0,
      processing: 'first',
      fenxi1: false,
      fenxi2: false,
      fenxi3: false
    }
  },
  // created() {
  //   this.script = document.createElement('script');
  //   this.script.setAttribute('async', '');
  //   this.script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7HRNBBW7L3';
  //   document.head.appendChild(this.script);

  //   this.script.onload = () => {
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){ dataLayer.push(arguments); }
  //     window.gtag = gtag;

  //     gtag('js', new Date());
  //     gtag('config', 'G-7HRNBBW7L3');
  //   };
  // },
  mounted () {
     fetch('/config.json')
      .then(response => response.json())
      .then(config => {
        // 创建script标签
        this.config = config
      })
      .catch(error => console.error('Failed to load config:', error));
  },
  methods: {
    startAnimation() {
            let current = 0;
            const timer = setInterval(() => {
                current = Math.min(current + 1, 100);
                this.progress1 = current;
                if (current === 100) {
                    this.fenxi1 = true
                    clearInterval(timer)
                    this.startAnimation2()
                };
            }, 10); // 每 20 毫秒增加 1%，约 2 秒完成
        },
        startAnimation2() {
            let current1  = 0;
            const timer1 = setInterval(() => {
                current1 = Math.min(current1 + 1, 100);
                this.progress2 = current1;
                if (current1 === 100) {
                    this.fenxi2 = true
                    clearInterval(timer1)
                    this.startAnimation3()
                };
            }, 10);
        },
        startAnimation3() {
            let current2  = 0;
            const timer2 = setInterval(() => {
                current2 = Math.min(current2 + 1, 100);
                this.progress3 = current2;
                if (current2 === 100) {
                    clearInterval(timer2);
                    this.fenxi3 = true
                    const timer3 = setInterval(() => {
                        this.processing = 'third'
                        clearInterval(timer3);
                    }, 1500)
                    
                }
            }, 10)
        },
        startProcess () {
        const stockCode = $('#stockCode').val().trim()
          if (!stockCode) {
              alert('株コードを入力してください')
              return
          }
            this.processing = 'second'
            this.startAnimation()
        },
      startDiagnosis () {
         const stockCode = $('#stockCode').val().trim()
          if (!stockCode) {
              alert('株コードを入力してください')
              return
          }
          // 显示诊断进度弹窗
          $('#diagnosisPopup').fadeIn()
          let progress = 0
          const progressBar = $('#progressBar')
          const resultPopup = $('#resultPopup')
          const resultText = $('#resultText')
          const resultTitle = $('#resultTitle') // 获取标题元素
          const progressText = $('#progressText')
          const getReportBtn = $('#getReportBtn')
          // 模拟诊断过程：多个步骤
          const steps = [{
              text: '株価データ分析中...',
              duration: 500
          }, {
              text: '企業収益分析中...',
              duration: 500
          }, {
              text: '市場のトレンド分析中...',
              duration: 500
          }, {
              text: '投資リスク評価中...',
              duration: 500
          }, {
              text: '最終診断結果を計算中...',
              duration: 500
          }];
          let currentStep = 0

          function nextStep() {
              if (currentStep < steps.length) {
                  const step = steps[currentStep]
                  progressText.text(step.text)
                  progress += (100 / steps.length) // 每步进度
                  progressBar.css('width', progress + '%')
                  // 更新诊断过程每步
                  currentStep++;
                  setTimeout(nextStep, step.duration)
              } else {
                  // 诊断完成
                  resultText.text('AIアシスタントを追加すると、関連銘柄の分析レポートが受け取れるほか、今日おすすめのAI優良銘柄も入手できる。')
                  // 更新弹窗标题，包含用户输入的股票代码
                //   resultTitle.text(stockCode + '；AI分析レポート完成')
                  resultTitle.text('AI分析レポート完成')
                  resultPopup.fadeIn();
                  $('#diagnosisPopup').fadeOut()
              }
          }
          // 启动诊断
          nextStep()
      },
      getReportBtn () {
        this.showline()
      },
      closePopup() {
        $('.popup').fadeOut()
      },
      showline() {
        //alert('showline'); return false;
        this.gtag_report_conversion(this.config.DL)
        // var xmlhttp;
        // if (window.XMLHttpRequest)
        // {
        //     xmlhttp=new XMLHttpRequest();
        // }
        // else
        // {
        //     xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
        // }
        
        // alert(xmlhttp)
        // xmlhttp.open("GET","st-ajax.php",true);
        // xmlhttp.send();
        // xmlhttp.onreadystatechange=function()
        // {
            
        //     alert(xmlhttp.readyState)
        //     alert(xmlhttp.status)
        //     if (xmlhttp.readyState==4 && xmlhttp.status==200)
        //     {
        //         var url_line = xmlhttp.responseText;
                
        //         alert('gtag_report_conversion')
        //         gtag_report_conversion(url_line);
        //     }
        // }
    },
    gtag_report_conversion(url) {
      var callback = function () {
          if (typeof(url) != 'undefined') {
          window.location = url;
          }
      };
      gtag('event', 'conversion', {
          'send_to': this.config.ZH,
          'transaction_id': '',
          'event_callback': callback
      });
      return false;
    }
  }
}
</script>
<style src="../css/bootstrap.min.css"></style>
<style src="../css/animate.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
        .page { margin: 0; padding: 0; font-family: Arial, sans-serif; 
            background-color: #fff;
            /* background: url("../img/BG.jpg") top center no-repeat;
            background-size: cover; */
        }
        .container {
            margin: 0 auto;
            max-width: 450px;
            width: 100%;
            min-height: 750px;
            height: 95vh;
            background: url("../img/BG.jpg") top center no-repeat;
            background-size: contain;
        }
        h1 { font-size: 2.5em;color: #fff; text-align: center;}
        .headPic {
            width: 90%;
            height: 310px;
            margin: 0 auto;
            background: url("../img/biaoti.png") top center no-repeat;
            background-size: contain;
        }
        .info {
            width: 80%;
            height: 438px;
            margin: 0 auto;
            background: url("../img/wenan.jpg") bottom center no-repeat;
            background-size: contain;
        }
        .info2{
            width: 90%;
            height: 520px;
            margin: 0 auto;
            margin-top: 10px;
            background: url("../img/jieshuwenan.jpg") bottom center no-repeat;
            background-size: contain;
        }
        .jiantou{
            width: 340px;
            height: 18px;
            margin: 0 auto;
            margin-top: 30px;
            background: url("../img/jiantou2.png") top center no-repeat;
            background-size: contain;
            animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
        }
        .progress-bg {
            height: 20px;
            background-color: #fff;
            /* 圆角 */
            overflow: hidden; /* 隐藏超出部分 */
            }

            .progress-bar {
            height: 100%;
            background-color: #3895f2; /* Vue 主题色 */
            transition: width 0.3s ease; /* 平滑过渡动画 */
            width: 0%; /* 初始宽度为 0 */
            }
            .fenxi{
                width: 50%;
                height: 400px;
                margin: 0 auto;
                background: url('../img/FENXI.png') bottom center no-repeat;
                background-size: contain;
            }
        .contentInput{
          border: 0px;
          background: url('../img/shuru2.jpg') top center no-repeat;
          background-size: cover;
          width: 340px;
          color: #838383;
          text-align: center;
          margin-top: 30px;
          height: 51px;
        }
        .contentButton{
          border: 0px;
          margin-top: 20px;
          background: url('../img/anniu.jpg') top center no-repeat;
          background-size: cover;
          width: 340px;
          height: 51px;
          animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
        }
        .contentButton2{
            border: 0px;
            margin-top: 20px;
            background: url('../img/jieshuanniu.jpg') top center no-repeat;
            background-size: cover;
            width: 400px;
            height: 61px;
            animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
        }
        .footer{
            margin: 0 auto;
            max-width: 600px;
            width: 100%;
            height: auto;
            text-align: center;
            background-color: #f8f8f8;
        }
        .box {
            background: #fff;
            border-radius: 8px;
            padding: 20px;
            margin: 20px;
            box-shadow: 0 4px 12px rgba(0,0,0,.07);
        }
        input::placeholder{
            color:#838383;
        }
        .progress {
            height: 30px;
        }

        .popup {
            display: none;
            background-color: black;
            color: #fff;
            padding: 0px;
            border-radius: 8px;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1000;
            width: 75%;
            text-align: center;
        }

        .popup .btn-close {
            color: white;
            font-size: 24px;
            border: none;
            /* background: transparent; */
        }
        #resultPopup .btn-report {
            margin-top: 0px;
            margin-bottom: 15px;
            font-size: 14px;
            background-color: #20C930;
            border-color: #20C930;
            color: white;
            animation: pulse 1s infinite;
            /* 应用跳动动画 */
        }
        
        #resultTitle {
            font-size: 14px;
            font-weight: bold;
            color: white;
            margin-bottom: 10px;
        }
        #resultPopup .btn-report {
          margin-top: 0px;
          margin-bottom: 15px;
          font-size: 14px;
          background-color: #20C930;
          border-color: #20C930;
          color: white;
          animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
        }
        /* 移动端样式 */
        @media (max-width: 768px) {
            .container { 
            padding: 0px;
            min-height: 820px;
            width: 100%;
            background: url("../img/BG.jpg") top center no-repeat;
            background-size: cover;
            }
            .headPic {
                width: 95%;
                margin: 0 auto;
                height: 280px;
                background: url("../img/biaoti.png") top center no-repeat;
                background-size: contain;
            }
            .footer{
                margin: 0 auto;
                margin-top: 30px;
                max-width: 600px;
                width: 100%;
                height: auto;
                text-align: center;
                background-color: #f8f8f8;
            }
            .info {
                width: 90%;
                height: 105vw;
                margin: 0 auto;
                background: url("../img/wenan.jpg") bottom center no-repeat;
                background-size: contain;
            }
            .info2{
                width: 90%;
                height: 125vw;
                margin: 0 auto;
                background: url("../img/jieshuwenan.jpg") bottom center no-repeat;
                background-size: contain;
            }
            h1 { font-size: 1.5em;color: #fff; text-align: center;}
            .box { padding: 10px; margin: 10px 0; }
            input::placeholder{
                color:#838383;
            }
            .fenxi{
                width: 50%;
                height: 92vw;
                margin: 0 auto;
                background: url('../img/FENXI.png') bottom center no-repeat;
                background-size: contain;
            }
            .jiantou{
                width: 340px;
                height: 18px;
                margin: 0 auto;
                margin-top: 30px;
                background: url("../img/jiantou2.png") top center no-repeat;
                background-size: contain;
                animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
            }
            .contentButton{
                border: 0px;
                margin-top: 10px;
                background: url('../img/anniu.jpg') top center no-repeat;
                background-size: cover;
                width: 340px;
                height: 52px;
                animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
            }
            .contentButton2{
                border: 0px;
                margin-top: 20px;
                background: url('../img/jieshuanniu.jpg') top center no-repeat;
                background-size: cover;
                width: 340px;
                height: 52px;
                animation: pulse 2s infinite; /* 设置动画持续时间为2秒 */
            }
        }
        
    </style>
